// Applies the per-audience theme by stamping data-audience on <html>. The token sets
// live in index.css. Staff = default (no attribute).
import { useEffect } from 'react';
import { ROLE_AUDIENCE, type Role } from '@alignova/shared';

export type Audience = 'staff' | 'clinic' | 'patient' | 'hr' | 'field';

export function applyAudience(audience: Audience): void {
  const root = document.documentElement;
  if (audience === 'staff') root.removeAttribute('data-audience');
  else root.setAttribute('data-audience', audience);
}

/** Drive the theme from the logged-in user's role (or a forced audience for public pages). */
export function useAudienceTheme(role: Role | undefined, forced?: Audience): void {
  useEffect(() => {
    const audience: Audience = forced ?? (role ? ROLE_AUDIENCE[role] : 'staff');
    applyAudience(audience);
  }, [role, forced]);
}
